import type {
  IReqLogin,
  IResLoginError,
  IResLoginOK,
  IResLoginUnauthorized,
} from '@/types/userSession/login.interface';
import type { KyInstance } from 'ky';

type UserLogin = ({
  userName,
  password,
}: IReqLogin) => Promise<IResLoginOK | IResLoginError | IResLoginUnauthorized>;

type TokenV3 = (token: string) => Promise<any>;

export interface IReqUserSession {
  userLogin: UserLogin;
  getTokenV3: TokenV3;
  // userForgetPassword: UserForgetPassword;
}
export function createReqUserSession(http: KyInstance): IReqUserSession {
  const route = 'api/user';

  return {
    userLogin: async ({ userName, password }) => {
      const response = await http.post(`${route}/login`, {
        json: { userName, password },
      });
      return response.json();
    },

    getTokenV3: async (token) => {
      const response = await http.get(`${route}/v3token`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.json();
    },
  };
}
